import { Fragment } from "react";
import { Field, Form } from "formik";
import { currencies } from "country-data";
import CurrencySelect from "../../components/inputs/CurrencySelect";
import { COLORS, UNDEFINED } from "../../constants";

import { Content, Heading, Button } from "react-bulma-components";

import {
  Field as BulmaField,
  Label,
  Input,
  Control,
  Help
} from "react-bulma-components/lib/components/form";

const CalculatorForm = ({
  values,
  errors,
  touched,
  setFieldValue,
  setShowResults,
  setFieldTouched
}) => (
  <Form className="earn-cal">
    <Content>
      <Heading size={5}>Network</Heading>
      <hr />
      This is an indicator for your reach.
    </Content>
    <BulmaField horizontal>
      <BulmaField.Label normal={`true`}>
        <Label>Facebook friends</Label>
      </BulmaField.Label>
      <BulmaField.Body>
        <div className="field is-expanded">
          <Control>
            <Field
              name="fbFriends"
              type="number"
              as={Input}
              color={COLORS.INFO}
            />
          </Control>
          <Help>How many friends do you have on Facebook/Instagram?</Help>
          {errors.fbFriends && touched.fbFriends ? (
            <Help color={COLORS.DANGER}>{errors.fbFriends}</Help>
          ) : null}
        </div>
      </BulmaField.Body>
    </BulmaField>
    <BulmaField horizontal>
      <BulmaField.Label normal={`true`}>
        <Label>LinkedIn connections</Label>
      </BulmaField.Label>
      <BulmaField.Body>
        <div className="field is-expanded">
          <Control>
            <Field
              name="linkedInFriends"
              type="number"
              as={Input}
              color={COLORS.INFO}
            />
          </Control>
          <Help>How many connections do you have on LinkedIn?</Help>
          {errors.linkedInFriends && touched.linkedInFriends ? (
            <Help color={COLORS.DANGER}>{errors.linkedInFriends}</Help>
          ) : null}
        </div>
      </BulmaField.Body>
    </BulmaField>
    {values.fbFriends > 0 && values.linkedInFriends > 0 && (
      <Fragment>
        <Content>
          Many of your Facebook friends are also your LinkedIn connections. How
          much is the overlap roughly?
        </Content>
        <BulmaField horizontal>
          <BulmaField.Label normal={`true`}>
            <Label>Network overlap</Label>
          </BulmaField.Label>
          <BulmaField.Body>
            <div className="field has-addons">
              <Control>
                <Field
                  name="duplication"
                  as={Input}
                  type="number"
                  color={COLORS.INFO}
                />
                <Help>In percentage</Help>
                {errors.duplication && touched.duplication ? (
                  <Help color={COLORS.DANGER}>{errors.duplication}</Help>
                ) : null}
              </Control>
              <Control>
                <a className="button is-static">%</a>
              </Control>
            </div>
          </BulmaField.Body>
        </BulmaField>
      </Fragment>
    )}
    <Content>
      <br />
      <Heading size={5}>Mentorship</Heading>
      <hr />
      Mentoring/Teaching others is a direct way to discover talent.
    </Content>
    <BulmaField horizontal>
      <BulmaField.Label normal={`true`}>
        <Label>Mentees</Label>
      </BulmaField.Label>
      <BulmaField.Body>
        <div className="field has-addons">
          <Control>
            <Field
              name="numMentees"
              as={Input}
              type="number"
              color={COLORS.INFO}
            />
            <Help>
              The number of people you're mentoring at work or outside
            </Help>
            {touched.numMentees && errors.numMentees ? (
              <Help color={COLORS.DANGER}>{errors.numMentees}</Help>
            ) : null}
          </Control>
        </div>
      </BulmaField.Body>
    </BulmaField>
    <Content>
      <br />
      <Heading size={5}>Common Salary</Heading>
      <hr />
      Referral bonus depends on employee salary. Off the top of your head, what
      is the common monthly salary in your network? You don't have to be super
      accurate.
    </Content>
    <BulmaField horizontal>
      <BulmaField.Label normal={`true`}>
        <Label>Monthly salary</Label>
      </BulmaField.Label>
      <BulmaField.Body>
        <div className="field is-expanded has-addons salary">
          <Control className="currency-code-select-wrapper">
            <Field
              name="monthlySalaryCurrency"
              as={CurrencySelect}
              setFieldValue={setFieldValue}
              setFieldTouched={setFieldTouched}
            />
          </Control>
          <Control>
            <Field
              name="monthlySalary"
              as={Input}
              type={"number"}
              color={COLORS.INFO}
            />
          </Control>
          {errors.duplication && touched.duplication ? (
            <Help color={COLORS.DANGER}>{errors.duplication}</Help>
          ) : null}
        </div>
      </BulmaField.Body>
    </BulmaField>
    <Button
      type="button"
      outlined
      color={COLORS.PRIMARY}
      onClick={() => {
        setShowResults(true);
        if (typeof window.fbq !== UNDEFINED) {
          window.fbq("track", "ViewContent", {
            content_name: "UsedEarningsCalculator",
            content_category: "Calculators"
          });
        }
        if (typeof gtag !== UNDEFINED) {
          gtag("event", "UsedEarningsCalculator");
        }
      }}
    >
      <b>Calculate</b>
    </Button>
  </Form>
);

export default CalculatorForm;
